<template>
  <custom-dialog class="project-item-dialog" :title="model.title" width="600px" :append-to-body="true" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-form-item :label="$t('components_addProjectDialog.xmssgs')" prop="orgId" v-if="model.type !== 'specialAdd'">
            <!--  -->
            <custom-select
              :disabled="model.type === 'edit'"
              v-model="form.orgId"
              url="organSonList"
              width="100%"
              filterable
              remote
              :listener="`${form.orgId}`"
              :props="{ label: 'orgName', value: 'orgId' }"
              :params="{ num: 50, keyword: form.orgName }"
              @change="onOrgName"
            ></custom-select>
          </el-form-item>
          <el-col>
            <el-form-item :label="$t('components_addProjectDialog.xiang_mu_ming_cheng')" prop="locationName">
              <el-input v-model="form.locationName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('components_addProjectDialog.xclxr')" prop="contactName">
              <el-input v-model="form.contactName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('components_addProjectDialog.lian_xi_ren_dian_hua')" prop="contactPhone">
              <el-input v-model="form.contactPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('components_addProjectDialog.yxxtzdgxmbz')" prop="isBasicGoal">
              <el-radio v-model="form.isBasicGoal" :label="1">{{ getDicValue('isynergy_cloud_bool', '1') }}</el-radio>
              <el-radio v-model="form.isBasicGoal" :label="0">{{ getDicValue('isynergy_cloud_bool', '0') }}</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="timeZoneList.length > 1">
          <el-col>
            <el-form-item :label="$t('components_addProjectDialog.mo_ren_shi_qu')" prop="timeZoneId">
              <custom-select v-model="form.timeZoneId" :data="timeZoneList" :auto="false" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item :label="$t('components_addProjectDialog.xiang_mu_di_zhi')" prop="detailAddress">
              <custom-address-select placeholder="" v-model="form.address" ref="address"></custom-address-select>
              <el-input v-model="form.detailAddress" type="textarea" :rows="2" class="detail-address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button type="primary" @click="onConfirm">
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
    <project-selectTag-dialog v-if="dialogVisible" :model="dialogModel" @close="getTagsList"></project-selectTag-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import customAddressSelect from '@/components/customAddressSelect.vue';
import dialogMixins from '@/mixins/dialog_mixins';
// import languageInjectMixins from '@/mixins/language_inject_mixins';
import projectSelectTagDialog from '@/components/projectSelectTagDialog.vue';

export default {
  mixins: [dialogMixins],
  components: {
    customAddressSelect,
    projectSelectTagDialog,
  },

  data() {
    return {
      inputVisible: false,
      inputValue: '',
      form: {
        // 项目名称
        locationName: '',
        // 负责人
        contactName: '',
        // 负责人电话
        contactPhone: '',
        // 项目地址（省市区）,
        address: [],
        // 详细地址
        detailAddress: '',
        // 项目标签
        tagNames: '',
        // 项目备注
        lat: '',
        lng: '',
        locationId: '',
        orgId: '',
        orgName: '',
        tagId: '',
        isBasicGoal: 1,
        timeZoneId: '',
      },
      timeZoneList: [],
      props: {
        label: 'name',
        value: 'nationRegionId',
      },
      dialogVisible: false,
      dialogModel: {},
    };
  },
  computed: {
    rules() {
      return {
        orgId: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        timeZoneId: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        locationName: [
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        contactName: [
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
        ],
        contactPhone: [
          {
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20]),
          },
        ],
        projectDesc: [
          {
            max: 200,
            message: this.$t('Common.com_rules_length_max', [200]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        detailAddress: { validator: this.checkAddress, required: true },
      };
    },
  },
  methods: {
    checkAddress(rule, value, cb) {
      if (this.form.detailAddress.length > 200) {
        cb(new Error(this.$t('components_addProjectDialog.cdzc200gzf')));
        return;
      }
      if (!this.form.detailAddress || !this.form.detailAddress.trim()) {
        cb(new Error(this.$t('Common.com_required')));
        return;
      }
      if (!this.form.address.length) {
        cb(new Error(this.$t('Common.com_required')));
        return;
      }
      cb();
    },
    getTimeZoneList: function (isInit) {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneList = res.data;
        if (this.timeZoneList.length > 0 && isInit) {
          this.form.timeZoneId = this.timeZoneList[0].timeZoneId;
        }
      });
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      if (this.model.type === 'add' || this.model.type === 'specialAdd') {
        this.add();
      } else {
        this.edit();
      }
    },
    edit() {
      this.$refs.form.validate((val) => {
        // 赋值 国家城市镇区
        const addressMsg = this.$refs.address.getAddressMsg();
        this.$setFormatData(this.form, addressMsg);
        if (val) {
          const reqData = this.getEditReqData();
          if (this.timeZoneList.length > 0 && !this.form.timeZoneId) {
            reqData.timeZoneId = this.timeZoneList[0].timeZoneId;
          }
          this.$postJSON(apis.locationUpdate, reqData, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.$emit('success', this.form);
          });
        }
      });
    },
    add() {
      this.$refs.form.validate((val) => {
        if (val) {
          const reqData = this.getAddReqData();
          this.$postJSON(apis.locationAdd, reqData, true).then(() => {
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success'),
            });
            this.$emit('success', this.form);
          });
        }
      });
    },
    getAddReqData() {
      const addressMsg = this.$refs.address.getAddressMsg();
      return {
        ...addressMsg,
        contactName: this.form.contactName,
        // 负责人电话
        contactPhone: this.form.contactPhone,
        detailAddress: this.form.detailAddress,
        lat: this.form.lat,
        lng: this.form.lng,
        projectDesc: this.form.projectDesc,
        locationId: this.form.locationId,
        locationName: this.form.locationName,
        orgId: this.form.orgId,
        orgName: this.form.orgName,
        tagId: this.form.tagId,
        isBasicGoal: this.form.isBasicGoal,
        timeZoneId: this.form.timeZoneId,
      };
    },
    getEditReqData() {
      return this.getAddReqData();
    },
    companyAddressDataFilter(list) {
      list.forEach((country) => {
        (country.children || []).forEach((province) => {
          (province.children || []).forEach((city) => {
            city.children = null;
          });
        });
      });
      return list;
    },
    handleInputConfirm() {
      const specialWord = [','];
      if (this.inputValue && this.inputValue.trim()) {
        if (specialWord.includes(this.inputValue)) {
          const tips = this.$t('components_addProjectDialog.byxtszf');
          this.$message.error(tips);
          return;
        }
        if (!this.tags.includes(this.inputValue)) {
          // computed 的tags不能用push，push无法触发set方法
          this.tags = [...this.tags, this.inputValue];
          this.inputVisible = false;
          this.inputValue = '';
        } else {
          const tips = this.$t('components_addProjectDialog.byxxtbq');
          this.$message.error(tips);
        }
      } else {
        const tips = this.$t('components_addProjectDialog.bu_yun_xu_wei_kong');
        this.$message.error(tips);
      }
    },
    showInput() {
      this.inputVisible = true;
    },

    handleClose(tag) {
      const newTags = this.tags.filter((item) => `${item}` !== `${tag}`);
      this.tags = newTags;
    },
    addTag() {
      //  this.dialogModel.type = '';
      this.dialogModel.title = this.$t('components_addProjectDialog.xiang_mu_biao_qian');
      this.dialogModel.data = {
        orgId: this.form.orgId,
        orgName: this.form.orgName,
        // ...data
      };
      this.dialogVisible = true;
    },
    getTagsList() {
      this.dialogVisible = false;
      this.$refs.tag.getSelectList();
    },
    getProjectInfo() {
      this.$getJSON(apis.locationInfo, { locationId: this.model.id }).then((res) => {
        const data = res.data || {};
        // console.log(this.model.data);
        this.$setFormatData(this.form, data);
        this.form.isBasicGoal = Number(data.isBasicGoal);
        // 地址
        this.form.address = [];
        if (data.countryCode) {
          this.form.address.push(data.countryCode);
        }
        if (data.provinceCode) {
          this.form.address.push(data.provinceCode);
        }
        if (data.cityCode) {
          this.form.address.push(data.cityCode);
        }
      });
    },
    onOrgName(item) {
      if (item) {
        this.form.orgName = item.orgName || '';
      } else {
        this.form.orgName = '';
      }
    },
    initForm() {
      // specialAdd是从合同过来 本来就有值并且不能改
      if (this.model.type === 'add' || this.model.type === 'specialAdd') {
        this.form.orgId = this.model.data.orgId;
        this.form.orgName = this.model.data.orgName;
        this.getTimeZoneList(true);
        return;
      }
      this.getTimeZoneList(false);
      this.getProjectInfo();
    },
  },
  mounted() {
    this.initForm();
  },
};
</script>

<style lang="scss">
.project-item-dialog {
  .el-tag--small {
    height: 32px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .el-tag + .button-new-tag {
    margin-left: 10px;
  }
  .el-tag + .input-new-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
  }
  .detail-address {
    margin-top: 10px;
  }
}
</style>
